<template>
    <div class="relative" style="min-width: 738px;">
        <div class="mb-5 mr-4 pb-2 flex justify-between border-b border-gray-300">
            <div v-if="showHeader" class="flex items-center" :class="{ 'my-3': smallHeader }">
                <h1 class="module-header" :class="{ 'text-2xl': smallHeader }">Proposals</h1>
                <div class="ml-3 flex items-center text-gray-600">
                    <div :class="{ 'text-2xl': smallHeader }">/</div>
                    <div class="ml-2 text-xl" :class="[smallHeader ? 'pt-2px' : 'pt-1']">{{ proposals.filtered.length }} of {{ proposals.all.length }}</div>
                </div>
            </div>
            <div v-if="showFilters" class="flex items-center">
                <slot name="action-buttons">
                    <button v-if="showCreateProposal && canCreateProposal" @click="$modal.show('create-proposal')" class="ml-6 flex items-center btn btn-small btn-indigo">
                        <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                        <span class="ml-2">Create Proposal</span>
                    </button>
                </slot>
            </div>
        </div>

        <div v-if="proposals.filtered.length">
            <table class="w-full">
                <thead class="cursor-pointer">
                    <tr>
                        <th></th>
                        <th class="pl-5">Existing Proposals</th>
                        <th class="text-center">Rev.</th>
                        <th class="text-right">Total Lease ($)</th>
                        <th class="text-right">Eff. Rent PRSF</th>
                        <th class="text-right">Avg PUSF ($)</th>
                        <th class="text-right">Avg Monthly Cost</th>
                        <th class="text-right">NPV</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(proposal, proposalIndex) in orderedProposals" :key="proposalIndex">
                        <td class="hidden lg:table-cell text-center w-16 h-16">
                            <a :href="`#${proposal.building.id}`">
                                <img :src="proposal.building.image.view_url" class="mx-auto w-12 h-12 object-cover rounded-md shadow-md">
                            </a>
                            <a href="#_" class="lightbox" :id="`${proposal.building.id}`">
                                <img :src="proposal.building.image.view_url">
                            </a>
                        </td>
                        <td class="leading-normal">
                            <a v-bind:href="proposal.view_url" class="block ml-5">
                                <p class="text-sm font-semibold">{{ proposal.building.address_line_1 }}</p>
                                <p class="text-xs">{{ proposal.building.city }}, {{ proposal.building.state }}</p>
                            </a>
                        </td>
                        <td class="text-center">{{ proposal.revision_number }}</td>
                        <td data-precision="0" :data-originalvalue="proposal.total_lease_cost" class="is-currency text-right">{{ formatCurrency(proposal.total_lease_cost, 0) }}</td>
                        <td data-precision="2" :data-originalvalue="proposal.effective_rent_prsf" class="is-currency text-right">{{ formatCurrency(proposal.effective_rent_prsf, 2) }}</td>
                        <td data-precision="2" :data-originalvalue="proposal.average_rent_pusf" class="is-currency text-right">{{ formatCurrency(proposal.average_rent_pusf, 2) }}</td>
                        <td data-precision="0" :data-originalvalue="proposal.average_monthly_cost" class="is-currency text-right">{{ formatCurrency(proposal.average_monthly_cost, 0) }}</td>
                        <td data-precision="0" :data-originalvalue="proposal.npv" class="is-currency text-right">{{ formatCurrency(proposal.npv, 0) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="! proposals.filtered.length">
            <p class="none-found">No Proposals Found</p>
        </div>

        <modal name="create-proposal" width="50%" height="auto" :clickToClose="true" :scrollable="true" draggable=".modal-header">
            <div>
                <create-proposal></create-proposal>
            </div>
        </modal>
    </div>
</template>

<script>   
    import { mapState } from 'vuex';

    export default {
        props: {
            proposalData: {
              type: Array,
              required: true
            },

            showHeader: {
              type: Boolean,
              default: true
            },

            smallHeader: {
              type: Boolean,
              default: false
            },

            showFilters: {
              type: Boolean,
              default: true
            },

            showCreateProposal: {
              type: Boolean,
              default: true
            },

            perPage: {
                type: Number,
                default: 10
            }
        },

        data() {
            return {
                
            }
        },

        mounted() {
            this.proposals.all = this.proposalData;
            this.proposals.filtered = this.proposalData;
        },

        computed: {
            ...mapState(['proposals']),

            canCreateProposal() {
                return this.$gate.can('create', 'project');
            },
            orderedProposals() {
                return _.orderBy(this.proposals.filtered, ['building_id', 'revision_number']);
            }
        },

        methods: {

        }
    }
</script>